//#region src/core/ui/fullscreen-button/data.ts
/** @internal */
const FullscreenButtonDataAttrs = {
	/** Present when fullscreen mode is active. */
	fullscreen: "data-fullscreen",
	/** Indicates fullscreen availability (`available`, `unavailable`, `unsupported`). */
	availability: "data-availability",
	/** Present when the button is non-interactive (mirrors `aria-disabled`). */
	disabled: "data-disabled",
	/** Present when the button is hidden because fullscreen is not available. */
	hidden: "data-hidden"
};
//#endregion
export { FullscreenButtonDataAttrs };
